import React, { useEffect } from "react";
import { Alert, Button, Card, Collapse, message, Select, Tag } from "antd";
import { Shield, Crown, UserCog, User, Eye } from "lucide-react";
import PermissionMatrix from "../../views/PermissionMatrix";
import "./MainRoleTab.css"; // custom css
import { use } from "react";

const { Option } = Select;
const { Panel } = Collapse;

// Roles definition
// const roles = {
//     admin: {
//         name: "Super Admin",
//         icon: Crown,
//         description: "Full system access and user management",
//         permissions: [
//             { "id": "brand", "name": "Brand", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true },
//             { "id": "branch", "name": "Branch", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true },
//             { "id": "screen", "name": "Screen", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true, "CanPublish": true },
//             { "id": "campaign", "name": "Campaign", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true, "CanPublish": true, "CanUpload": true },
//             { "id": "playlist", "name": "Playlist", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true, "CanPublish": true },
//             { "id": "media", "name": "Media", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true, "CanUpload": true },
//             { "id": "media-trash", "name": "Media Trash", "CanRead": true, "CanDelete": true, "CanCreate": true, "CanUpdate": true, "CanPublish": true, "CanUpload": true },
//             { "id": "widget", "name": "Widget", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true },
//             { "id": "event", "name": "Event", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true },
//             { "id": "dashboard", "name": "Dashboard", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true, "CanPublish": true, "CanUpload": true },
//             { "id": "analytics", "name": "Analytics", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true, "CanPublish": true, "CanUpload": true },
//             { "id": "activity-log", "name": "Activity Log", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true, "CanPublish": true, "CanUpload": true },
//             { "id": "media-log", "name": "Media Log", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true, "CanPublish": true, "CanUpload": true },
//             { "id": "user", "name": "User", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true },
//             { "id": "role", "name": "Role", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true },
//             { "id": "permission", "name": "Permission", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true }
//         ]

//     },
//     manager: {
//         name: "Brand Manager",
//         icon: UserCog,
//         description: "Manage content and users within assigned brands",
//         permissions: [
//             { "id": "brand", "name": "Brand", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": false },
//             { "id": "branch", "name": "Branch", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true },
//             { "id": "screen", "name": "Screen", "CanRead": true, "CanCreate": true, "CanUpdate": true },
//             { "id": "campaign", "name": "Campaign", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanPublish": true },
//             { "id": "playlist", "name": "Playlist", "CanRead": true, "CanCreate": true, "CanUpdate": true },
//             { "id": "user", "name": "User", "CanRead": true }
//         ]
//     },
//     editor: {
//         name: "Content Editor",
//         icon: User,
//         description: "Create and edit content within assigned brands",
//         permissions: [
//             { "id": "campaign", "name": "Campaign", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanDelete": true, "CanPublish": true },
//             { "id": "playlist", "name": "Playlist", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanPublish": true, "CanDelete": true },
//             { "id": "media", "name": "Media", "CanRead": true, "CanCreate": true, "CanUpdate": true, "CanUpload": true, "CanDelete": true },
//             { "id": "widget", "name": "Widget", "CanRead": true, "CanCreate": true, "CanUpdate": true },
//             { "id": "event", "name": "Event", "CanRead": true, "CanCreate": true, "CanUpdate": true }
//         ]
//     },
//     viewer: {
//         name: "Viewer",
//         icon: Eye,
//         description: "View content and basic analytics only",
//         permissions: [
//             { "id": "dashboard", "name": "Dashboard", "CanRead": true, "CanDelete": false, "CanUpdate": false, "CanCreate": false, "CanPublish": false, "CanUpload": false },
//             { "id": "analytics", "name": "Analytics", "CanRead": true, "CanDelete": false, "CanUpdate": false, "CanCreate": false, "CanPublish": false, "CanUpload": false },
//             { "id": "activity-log", "name": "Activity Log", "CanRead": true, "CanDelete": false, "CanUpdate": false, "CanCreate": false, "CanPublish": false, "CanUpload": false },
//             { "id": "media-log", "name": "Media Log", "CanRead": true, "CanDelete": false, "CanUpdate": false, "CanCreate": false, "CanPublish": false, "CanUpload": false }
//         ]
//     }
// };

const subscriptionLimits = {
    basic: [
        "view_content",
        "edit_content",
        "create_content",
        "view_basic_analytics"
    ],
    pro: [
        "view_content",
        "edit_content",
        "create_content",
        "view_analytics",
        "manage_media",
        "manage_team",
        "api_access"
    ],
    business: [
        "manage_users",
        "manage_content",
        "manage_brands",
        "manage_settings",
        "view_analytics",
        "manage_billing",
        "api_access",
        "system_admin",
        "create_content",
        "edit_content",
        "view_content",
        "view_basic_analytics",
        "manage_media",
        "manage_team"
    ]
};

const MainRoleTab = ({ userData, subscriptionPlans = [], currentUserData, roles = [], setUserData, onDataChange = () => { }, onStepComplete = () => { } }) => {

    const [selectedRoles, setSelectedRoles] = React.useState([]);
    // Handle multi-role change
    const handleRolesChange = (selectedRoles) => {
        setSelectedRoles(selectedRoles);
        // setUserData({ ...userData, roles: selectedRoles });
    };

    useEffect(() => {
        onDataChange(selectedRoles);
    }, [selectedRoles]);

    useEffect(() => {
        if (userData && userData.roles) {
            const roleIDs = userData.roles.map(r => r.roleid);
            setSelectedRoles(roleIDs);
        }
        else
            setSelectedRoles([]);
    }, [userData]);

    // useEffect(() => {
    //     //compatre selectedRoles with userData.roles
    //     const currentRoleIDs = userData && userData.roles ? userData.roles.map(r => r.roleid) : [];
    //     const isDifferent = (selectedRoles.length !== currentRoleIDs.length) || !selectedRoles.every(rid => currentRoleIDs.includes(rid));
    //     setHasChanges(isDifferent);
    // }, [selectedRoles, userData]);

    useEffect(() => {
        console.log("**** selectedRoles changed: " + JSON.stringify(selectedRoles));
    }, [selectedRoles]);
    useEffect(() => {
        console.log("MainRoleTab ROLES " + JSON.stringify(roles));
        console.log("MainRoleTab userData " + JSON.stringify(userData));
    }, []);


    const handleContinue = () => {
        // setUserData({ ...userData, roles: selectedRoles });

        if (!selectedRoles || selectedRoles.length === 0) {
            message.error("Please select at least one role");
            return;
        }

        onDataChange(selectedRoles);
        onStepComplete();
    };

    // Merge permissions from all selected roles
    const mergedPermissions = {};

    (selectedRoles || []).forEach((roleid) => {
        const role = roles.find(r => r.userroleid === roleid);
        if (!role) return;

        console.log("user roles " + JSON.stringify(role));
        Object.keys(role.userrolepermissions).forEach((menuName) => {
            const perm = role.userrolepermissions[menuName];
            if (!mergedPermissions[menuName]) {
                mergedPermissions[menuName] = { ...perm, name: menuName };
            } else {
                // Union logic: take the max (1 wins over 0)
                Object.keys(perm).forEach((key) => {
                    if (key === "id" || key == "name") return;
                    mergedPermissions[menuName][key] =
                        (mergedPermissions[menuName][key] || perm[key] || false) ? true : false;
                });
            }
        });
    });

    console.log("Merged Permissions:", JSON.stringify(mergedPermissions));
    const allowedPermissions = userData && userData.subscriptionPlan ? subscriptionLimits[userData.subscriptionPlan] : [];

    return (
        <div className="main-role-tab">
            <Card
                title={
                    <span className="card-title">
                        <Shield size={16} /> Main Role Assignment
                    </span>
                }
                style={{ marginBottom: 16 }}
            >
                <div className="role-select-section">
                    <label className="role-label">Select Roles</label>
                    <Select
                        mode="multiple"
                        placeholder="Select one or more roles"
                        value={selectedRoles || []}
                        onChange={handleRolesChange}
                        style={{ width: "100%" }}
                    >
                        {roles.map(({ userroleid, userrolename }) => {
                            // const Icon = role.icon;
                            return (
                                <Option key={userroleid} value={userroleid}>
                                    <div className="role-option">
                                        {/* <Icon size={14} /> */}
                                        <span>{userrolename}</span>
                                    </div>
                                </Option>
                            );
                        })}
                    </Select>
                </div>

                {/* <div className="role-description-box">
                    {(userData && userData.roles ? userData.roles : []).map((userRole) => {
                        const role = roles.find(r => r.userroleid === userRole.roleid);
                        if (!role || !("description" in role)) return null;
                        // const Icon = role.icon;
                        return (
                            <div key={role.userroleid} className="role-description-item">
                                <div className="role-description-header">
                                    <h4 className="role-title">{role.userrolename} Role</h4>
                                </div>
                                <p className="role-description">{role.description}</p>
                            </div>
                        );
                    })}
                </div> */}
                {selectedRoles && selectedRoles.length>0 && <Collapse bordered={false}>
                <Panel header="Click to Show Inherited Permissions" extra={
                    <span className="permissions-note">
                        These permissions are automatically granted by selected roles
                    </span>
                }>
                    <PermissionMatrix
                        role={{ permissions: Object.values(mergedPermissions) }}
                        isPermissionLocked={(menu, permissionKey) => {
                            if (currentUserData && currentUserData.planid) {
                                console.log("Current user planid " + JSON.stringify(currentUserData));
                                const plan = subscriptionPlans.find(p => p.planid === currentUserData.planid);
                                console.log("Current plan " + JSON.stringify(plan));

                                console.log("Check lock " + menu + " " + permissionKey);
                                if (plan && plan.permissions && plan.permissions[menu]) {
                                    return !plan.permissions[menu][permissionKey];
                                }
                            }
                            else if (userData && userData.plan) {
                                const plan = subscriptionPlans.find(p => p.planid === userData.plan.planid);
                                console.log("User plan " + JSON.stringify(plan));
                                console.log("Check lock " + menu + " " + permissionKey);

                                if (plan && plan.permissions && plan.permissions[menu]) {
                                    return !plan.permissions[menu][permissionKey];
                                }
                            }
                            else {
                                return false;
                            }
                            return false;
                        }}
                        isReadOnly
                    />
                </Panel>

            </Collapse>}
            
            </Card>

            {!userData && <Button type="primary" block onClick={handleContinue}>
                Next
            </Button>}
        </div>
    );
};

export default MainRoleTab;
